import React, { createContext, useState, useEffect, useCallback } from 'react';
import CryptoJS from 'crypto-js';

const AuthContext = createContext();

const secretKey = process.env.REACT_APP_ENCRYPTION_KEY || 'default_secret_key';

const encryptData = (data) => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  } catch (e) {
    console.error("Encryption error:", e);
    return null;
  }
};

const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (e) {
    console.error("Decryption error:", e);
    return null;
  }
};

function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    // Check if user data exists in local storage
    console.log('Checking for user data in local storage');
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const decryptedUser = decryptData(storedUser);
      if (decryptedUser) {
        setUser(decryptedUser);
        setIsLoggedIn(true);
      } else {
        localStorage.removeItem('user');
      }
    }
  }, []);

  const login = useCallback((userData) => {
    setUser(userData);
    setIsLoggedIn(true);
    const encryptedData = encryptData(userData);
    if (encryptedData) {
      localStorage.setItem('user', encryptedData);
    }
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    setIsLoggedIn(false);
    localStorage.removeItem('user');
  }, []);

  const updateUser = useCallback((updatedUserData) => {
    const newUserData = { ...user, ...updatedUserData };
    setUser(newUserData);
    const encryptedData = encryptData(newUserData);
    if (encryptedData) {
      localStorage.setItem('user', encryptedData);
    }
  }, [user]);

  const contextValue = React.useMemo(() => ({
    user,
    isLoggedIn,
    login,
    logout,
    updateUser,
        isLocked,
        setIsLocked,
  }), [user, isLoggedIn, login, logout, updateUser, isLocked, setIsLocked]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
